import ViewFiles from "components/Services/environment/en/ViewFiles"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Card, Container, CardBody, Row, Col } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import General from "services/GeneralEndpoints"

const user = JSON.parse(localStorage.getItem("authUser"))
let generalService = new General(user)
const BASE_URL = process.env.REACT_APP_BASE_URL

const ViewApplication = props => {
  const [certUrl, setCertUrl] = useState()

  useEffect(() => {
    // console.log("See download here -- ", props.appDetails)
    if (props.appDetails.application_status_id === 6) {
      fetchCertUrl(props.appDetails.app_id)
    }
  }, [])

  const fetchCertUrl = appId => {
    generalService.getCertificate(appId).then(response => {
      console.log(response)
      setCertUrl(BASE_URL+"verify/certificate/" + appId)
    })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>View Application</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs
            maintitle="Dashboard"
            title="View Application"
            breadcrumbItem={props.service}
          />

          <Card>
            <CardBody>
              <h4 className="card-title mb-4">{props.service}</h4>

              {props.appDetails.application_status_id === 6 ? (
                <Row>
                  <Col md={8}>
                  <h4>Application Approved</h4>
                  </Col>
                  <Col md={4}>
                    
                    <a href={certUrl} className="btn btn-success" target="_blank">
                      View Certificate
                    </a>
                  </Col>


                </Row>
              ) : null}
<br></br>
              {/* View Files will go here */}
              <Row>
                <h5>Application Attachments</h5>
                <ViewFiles attachments={props.attachments} />
              </Row>
              {/* End of View Files will go here */}

              <hr></hr>
              {/* Dynamic form data will be rendered here  */}
              <Row>{props.appDetailsComponent}</Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ViewApplication
